import { useState, useEffect } from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import api from "services/api";
import SignedDownloadButton from "pages/Clients/sections/desc/SignedDownloadButton";

import { useTranslation } from "react-i18next";

import bgImage from "assets/images/bg-user-info.jpg";

function UserHero() {
  const { t } = useTranslation();

  const [software, setSoftware] = useState(null);
  const softwareItems = software?.items || [];
  const installerSoftware =
    softwareItems.find((item) => item.variant === "installer") || software?.current || software;
  const standaloneSoftware = softwareItems.find((item) => item.variant === "standalone");

  useEffect(() => {
    api
      .get("/software/windows/")
      .then((res) => {
        setSoftware(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <MKBox
      minHeight="52vh"
      width="100%"
      sx={({ breakpoints }) => ({
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        [breakpoints.down("md")]: {
          paddingTop: "6rem",
          paddingBottom: "6rem",
        },
      })}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              textAlign: "center",
              mt: { xs: 2, md: 0 },
            }}
          >
            <MKTypography variant="h4" color="white" fontWeight="bold">
              {software?.name || t("clients.windows.softwareName")} for Windows {/* 软件名称 */}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.8} mt={1}>
              {t("clients.windows.supportedDevices")} {/* 适用设备 */}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.8} mt={0.5}>
              {t("clients.windows.currentVersionLabel")}:{" "}
              {software?.version || t("clients.windows.version")}
            </MKTypography>
            <MKBox mt={2} display="flex" flexWrap="wrap" justifyContent="center" gap={1.5}>
              {installerSoftware?.signed_link_url ? (
                <SignedDownloadButton
                  variant="outlined"
                  color="white"
                  linkUrl={installerSoftware.signed_link_url}
                  label={t("clients.windows.downloadInstaller")}
                />
              ) : null}
              {standaloneSoftware?.signed_link_url ? (
                <SignedDownloadButton
                  variant="outlined"
                  color="white"
                  linkUrl={standaloneSoftware.signed_link_url}
                  label={t("clients.windows.downloadPortable")}
                />
              ) : null}
            </MKBox>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              mt: { xs: 4, md: 0 },
            }}
          >
            <MKTypography variant="h5" color="white" fontWeight="bold">
              {t("clients.windows.usage.title")} {/* 使用说明标题 */}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.85} mt={1}>
              1. {t("clients.windows.usage.step1")}
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.85} mt={0.5}>
              2. {t("clients.windows.usage.step2")}
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.85} mt={0.5}>
              3. {t("clients.windows.usage.step3")}
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.85} mt={0.5}>
              4. {t("clients.windows.usage.step4")}
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default UserHero;
